class BannerVideo {
  constructor(
    element: HTMLElement,
    playButton: HTMLButtonElement,
    playButtonText: HTMLElement,
    video: HTMLVideoElement,
  ) {
    this.element = element;
    this.playButton = playButton;
    this.playButtonText = playButtonText;
    this.video = video;
    this.init();
  }

  element: HTMLElement;
  playButton: HTMLButtonElement;
  playButtonText: HTMLElement;
  video: HTMLVideoElement;

  init() {
    this.playButton.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play();
        this.playButton.classList.remove('paused');
        this.playButtonText.textContent = 'Pause Video';
      } else {
        this.video.pause();
        this.playButton.classList.add('paused');
        this.playButtonText.textContent = 'Play Video';
      }
    });
  }
}

document.querySelectorAll('[video-banner]').forEach((banner) => {
  const element = banner as HTMLElement;
  const playButton = element.querySelector('[banner-play]');
  const video = element.querySelector('[banner-video]');

  if (!playButton || !video) {
    return;
  }

  const playButtonText = playButton.querySelector('[banner-play-text]');

  if (!playButtonText) {
    return;
  }

  new BannerVideo(
    element,
    playButton as HTMLButtonElement,
    playButtonText as HTMLElement,
    video as HTMLVideoElement,
  );
});
